/**
 * Central list of languages and shared typing.
 * This file is used across middleware, i18n setup, layout, etc.
 */

export const languages = ['en', 'pt'];
export type Language = typeof languages[number]

/** Fallback language (used when detection fails) */
export const defaultLanguage: Language = 'en'

/**
 * Namespaces allow splitting translations across domains.
 * Example: "common", "auth", "dashboard"
 * For now, we only use "common".
 */
export const namespaces = ['common', 'auth', 'subscription', 'subscriptionTags', 'account', 'productCatalog', 'backgroundTasks'] as const
